import React, { memo } from "react";
import { ViewKanban } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const KanbanLaneNode = memo(({ id, data, isConnectable, selected }) => {
  const mode = data?.kanbanMode === "enterprise" ? "Enterprise" : "Clássico";
  const laneName =
    data?.kanbanMode === "enterprise"
      ? data?.enterpriseLane?.name
      : data?.classicLane?.name;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ViewKanban />}
      title="Kanban Lane"
      color="#1565C0"
      bgColor="#E3F2FD"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div style={{ fontSize: 10, color: "#1565C0", fontWeight: 700, marginBottom: 4 }}>
        {mode}
      </div>
      <div
        style={{
          fontSize: 11,
          color: laneName ? "#333" : "#999",
          fontWeight: 600,
          padding: "4px 8px",
          borderRadius: 6,
          background: "#fff",
          border: "1px solid #90CAF9",
        }}
      >
        {laneName || "Selecione uma lane"}
      </div>
    </NodeWrapper>
  );
});

KanbanLaneNode.displayName = "KanbanLaneNode";
export default KanbanLaneNode;
